import { z } from 'zod';
/**
 * Sistema de notificaciones in-app.
 *
 * Las notificaciones se persisten en BBDD (modelo Notification + enum
 * NotificationType del schema Prisma) y se entregan vía polling desde el
 * frontend. La deduplicación se hace con dedupeKey @@unique [userId, dedupeKey].
 */
export const NotificationTypeSchema = z.enum([
    'TASK_DUE',
    'TASK_OVERDUE',
    'MILESTONE_DUE',
    'MILESTONE_OVERDUE',
    'INVOICE_OVERDUE',
    'OPPORTUNITY_STALE',
    'OPPORTUNITY_STAGE_CHANGED',
    'INVOICE_DRAFT_READY',
    // OJO: este enum tiene que ir A LA PAR del NotificationType de Prisma. Si el
    // backend emite un tipo que no está aquí, el parse del listado revienta y la
    // campana devuelve 500 — ya pasó con INVOICE_DRAFT_READY.
    'BANK_CONSENT_EXPIRING',
    'SYSTEM',
]);
export const NotificationTypeLabel = {
    TASK_DUE: 'Tarea próxima',
    TASK_OVERDUE: 'Tarea vencida',
    MILESTONE_DUE: 'Hito próximo',
    MILESTONE_OVERDUE: 'Hito vencido',
    INVOICE_OVERDUE: 'Factura vencida',
    OPPORTUNITY_STALE: 'Oportunidad estancada',
    OPPORTUNITY_STAGE_CHANGED: 'Cambio de etapa',
    INVOICE_DRAFT_READY: 'Borrador de factura listo',
    BANK_CONSENT_EXPIRING: 'Conexión bancaria por caducar',
    SYSTEM: 'Sistema',
};
export const NotificationDtoSchema = z.object({
    id: z.string(),
    type: NotificationTypeSchema,
    title: z.string(),
    body: z.string().nullable(),
    link: z.string().nullable(),
    metadata: z.unknown().nullable(),
    readAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
});
export const NotificationListResponseSchema = z.object({
    items: z.array(NotificationDtoSchema),
    unreadCount: z.number().int().nonnegative(),
});
//# sourceMappingURL=notifications.js.map